export function OrganizationSchema() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "LegaSecure",
    "url": "https://legasecure.com",
    "logo": "https://legasecure.com/logo.png",
    "description": "Digital legacy planning and estate protection for Filipinos worldwide.",
    "address": { "@type": "PostalAddress", "streetAddress": "103 Suite C, 10th Street", "addressLocality": "New Manila, Quezon City", "postalCode": "1112", "addressCountry": "PH" },
    "sameAs": ["https://facebook.com/legasecure", "https://instagram.com/legasecure", "https://linkedin.com/company/legasecure"]
  };
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />;
}

export function WebSiteSchema() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "LegaSecure Guide",
    "url": "https://legasecure.net",
    "description": "Complete guide to estate planning, SPA, and legacy protection for Filipinos and OFWs worldwide.",
    "publisher": { "@type": "Organization", "name": "LegaSecure", "url": "https://legasecure.com" }
  };
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />;
}

export function ServiceSchema() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "LegaSecure Estate Planning",
    "provider": { "@type": "Organization", "name": "LegaSecure", "url": "https://legasecure.com" },
    "description": "Digital estate planning, Online SPA, Guardian Mandates, and Zero-Knowledge Digital Vault for Filipinos and OFWs.",
    "areaServed": { "@type": "Country", "name": "Philippines" },
    "serviceType": "Estate Planning"
  };
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />;
}

export function FAQSchema({ faqs }) {
  if (!faqs || faqs.length === 0) return null;
  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(f => ({
      "@type": "Question",
      "name": f.question,
      "acceptedAnswer": { "@type": "Answer", "text": f.answer }
    }))
  };
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />;
}

export function BreadcrumbSchema({ items }) {
  const schema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, i) => ({
      "@type": "ListItem",
      "position": i + 1,
      "name": item.name,
      "item": item.url ? `https://legasecure.net${item.url}` : undefined
    }))
  };
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />;
}

export function SpeakableSchema({ selectors }) {
  const schema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "speakable": { "@type": "SpeakableSpecification", "cssSelector": selectors || ["h1", ".speakable-intro"] }
  };
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />;
}

export function ArticleSchema({ title, description, url, datePublished, author }) {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": title,
    "description": description,
    "url": `https://legasecure.net${url}`,
    "datePublished": datePublished,
    "author": { "@type": "Organization", "name": author || "LegaSecure Guide" },
    "publisher": { "@type": "Organization", "name": "LegaSecure", "url": "https://legasecure.com" }
  };
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />;
}

export function HowToSchema({ name, steps }) {
  const schema = {
    "@context": "https://schema.org",
    "@type": "HowTo",
    "name": name,
    "step": steps.map((s, i) => ({ "@type": "HowToStep", "position": i + 1, "name": s.name, "text": s.text }))
  };
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />;
}
